// @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (s?: string | null, defaultValue: number = undefined): number | undefined => {
	if (s === undefined || s === null) return undefined;

	const num = parseInt(s, 10);

	if (Number.isNaN(num)) {
		return defaultValue;
	}

	return num;
};
